'use client';

import type { Locale } from '@tuic/i18n';
import type { FC } from 'react';
import { useClientTranslation } from '@lib/i18n/client';

type Props = {
  locale: Locale;
};

export const SetClientLocale: FC<Props> = ({ locale }) => {
  useClientTranslation(locale);

  return null;
};
